import api from '../utils/api'

const base = (businessId) => `/api/businesses/${businessId}/consent-forms`

// ---------- 範本 ----------

export const listConsentFormTemplates = (businessId, params = {}) =>
  api({
    url: `${base(businessId)}/templates`,
    method: 'get',
    params
  })

export const getConsentFormTemplate = (businessId, templateId) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'get'
  })

export const createConsentFormTemplate = (businessId, data) =>
  api({
    url: `${base(businessId)}/templates`,
    method: 'post',
    data
  })

export const updateConsentFormTemplate = (businessId, templateId, data) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'put',
    data
  })

export const deleteConsentFormTemplate = (businessId, templateId, data = {}) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'delete',
    data
  })

// ---------- 待簽 / 簽署紀錄 ----------

export const listConsentForms = (businessId, params = {}) =>
  api({
    url: base(businessId),
    method: 'get',
    params
  })

export const getConsentFormDetail = (businessId, requestId) =>
  api({
    url: `${base(businessId)}/${requestId}`,
    method: 'get'
  })

export const listConsentFormsByBooking = (businessId, bookingId) =>
  api({
    url: `${base(businessId)}/by-booking/${bookingId}`,
    method: 'get'
  })

export const listConsentFormsByCustomer = (businessId, customerId) =>
  api({
    url: `${base(businessId)}/by-customer/${customerId}`,
    method: 'get'
  })

export const sendConsentForm = (businessId, data) =>
  api({
    url: `${base(businessId)}/send`,
    method: 'post',
    data
  })

export const resendConsentForm = (businessId, requestId) =>
  api({
    url: `${base(businessId)}/${requestId}/resend`,
    method: 'post'
  })

export const cancelConsentForm = (businessId, requestId) =>
  api({
    url: `${base(businessId)}/${requestId}/cancel`,
    method: 'post'
  })

// ---------- 購買同意書（堂票發放 / 儲值） ----------

/**
 * 取得此購買行為適用的購買同意書（target: 'classTicket' | 'balance'）。
 * classTicketTemplateId：正在買哪一種堂票；同意書有限定堂票時據此過濾。
 */
export const listPurchaseApplicableForms = (
  businessId,
  target,
  classTicketTemplateId
) =>
  api({
    url: `${base(businessId)}/purchase/applicable`,
    method: 'get',
    params: {
      target,
      ...(classTicketTemplateId ? { classTicketTemplateId } : {})
    }
  })

// POS 現場即時簽署（回傳 signatureId 供發放/儲值帶入）
export const signConsentInline = (businessId, data) =>
  api({
    url: `${base(businessId)}/sign-inline`,
    method: 'post',
    data
  })

// 遠端簽：發送購買同意書給客人（App／網頁簽）
export const sendPurchaseConsent = (businessId, data) =>
  api({
    url: `${base(businessId)}/send-purchase`,
    method: 'post',
    data
  })

// 留存列印 / 另存 PDF：以新分頁開啟後端回傳的自包含 HTML
export const consentFormPrintableUrl = (businessId, requestId) =>
  `${base(businessId)}/${requestId}/pdf`

// 狀態顯示對應
export const CONSENT_STATUS_META = {
  pending: { color: 'orange', label: '待簽署' },
  viewed: { color: 'gold', label: '已讀待簽' },
  signed: { color: 'green', label: '已簽署' },
  declined: { color: 'default', label: '已拒簽' },
  expired: { color: 'red', label: '已逾期' },
  canceled: { color: 'default', label: '已取消' }
}

// 免登入簽署連結（客人沒有美感帳號／LINE 時，店家自己傳或店內開啟現場簽）
export const getConsentSignLink = (businessId, requestId) =>
  api({
    url: `${base(businessId)}/${requestId}/sign-link`,
    method: 'get'
  })
